import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { BackOrga, Icon } from '@weezevent/nacre';
import Styles from '../../styles/eventCreation/eventCreationStepSideBar.module.css';
import { useHistory, Link } from 'react-router-dom';
import { useSegment } from '../../components/tracking/trackingProvider';

export function IconStatusStep({ statusStep }) {
    return <Icon name={statusStep === 'open' ? 'arrow-right' : 'check-circle'} className={`${Styles['icon-status-step']} ${Styles['icon-status-step-' + statusStep]}`} />;
}

IconStatusStep.propTypes = {
    statusStep: PropTypes.string
};

export function LabelOrganization({ organization, hasEvents }) {
    const { t } = useTranslation();

    return hasEvents ? (
        <Link className={Styles['link-organization']} target="_blank" to={`/ticket/O${organization.pk}/organization/profile`}>
            <Icon name="institution" />
            {t('context_menu.catchphrase_orga', { id: organization.id })}
        </Link>
    ) : (
        <span className={Styles['label-organization']}>
            <Icon name="institution" />
            {t('context_menu.catchphrase_orga', { id: organization.id })}
        </span>
    );
}

IconStatusStep.propTypes = {
    statusStep: PropTypes.string
};

export default function EventCreationStepSideBar({ steps, labels, organization, organizationInfos }) {
    const { t } = useTranslation();
    const { track } = useSegment();
    const history = useHistory();

    let backToOrga = (
        <BackOrga
            className={Styles['step-sidebar-back-orga']}
            displayText={[t('back_to_orga.generic'), t('back_to_orga.organization', { id: organization.id })]}
            onClick={() => {
                track('ACTION > BACK TO HOME MENU CREATE EVENT', { 'Page Title': 'CREATE EVENT' });
                history.push(`/ticket/O${organization.id}`);
            }}
            dropdownTitle={t('back_to_orga.dropdown_title')}
        />
    );

    return (
        <div className={Styles['step-sidebar-container']}>
            <div className={Styles['step-sidebar-header']}>
                <div className={Styles['header-organization']}>
                    <LabelOrganization organization={organization} hasEvents={organizationInfos.has_event} />
                </div>
                <div className={Styles['header-content']}>
                    <div className={Styles['']}>
                        <svg className={Styles['step-sidebar-header-weez-logo']} />
                    </div>
                    <div className={Styles['step-sidebar-header-title']}>
                        {organizationInfos.has_event ? t('ticket.creationEvent.stepSideBar.title') : t('ticket.creationEvent.stepSideBar.titleFirstEvent')}
                    </div>
                    <div className={Styles['step-sidebar-header-text']}>
                        {organizationInfos.has_event ? t('ticket.creationEvent.stepSideBar.subtitle') : t('ticket.creationEvent.stepSideBar.subtitleFirstEvent')}
                    </div>
                </div>
            </div>
            <div>
                <ul className={Styles['step-sidebar-steps-list']}>
                    {Object.entries(steps).map(([index, status]) => (
                        <li className={`${Styles['step-sidebar']} ${Styles['step-sidebar-steplabel-' + status]}`} key={'step_' + index}>
                            <IconStatusStep statusStep={status} />
                            {labels[index]}
                        </li>
                    ))}
                </ul>
            </div>
            {organizationInfos.has_event && <div className={Styles['step-sidebar-back-orga-container']}>{backToOrga}</div>}
        </div>
    );
}

EventCreationStepSideBar.propTypes = {
    steps: PropTypes.object.isRequired,
    labels: PropTypes.object.isRequired,
    organization: PropTypes.object.isRequired,
    organizationInfos: PropTypes.object.isRequired
};
